module.exports = __webpack_public_path__ + "media/feature/indonesia-04fa784c.jpg";